import { fromFetch } from 'rxjs/fetch';
import { switchMap, of, catchError } from 'rxjs';
import { listingCounts } from 'constants/routes'

/**
 * getListingCounts: observable to fetch the nation wide counts
 * response.text() to map the partial result
 */
 const getListingCounts$ = (marketId) => {
   const url = `${listingCounts}?marketId=${encodeURIComponent(marketId)}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }).pipe(
    switchMap((response) => response.text()),
    catchError(() => of(''))
  );
}

export default getListingCounts$;